// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3qf0h","log":"ModalInventoryLogs_log__FW8o7","date":"ModalInventoryLogs_date__1k-p6","userName":"ModalInventoryLogs_userName__h53T3"};